import { render, staticRenderFns } from "./RevenueManagerUnitActionForm.vue?vue&type=template&id=98545eaa&scoped=true&"
import script from "./RevenueManagerUnitActionForm.vue?vue&type=script&lang=js&"
export * from "./RevenueManagerUnitActionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98545eaa",
  null
  
)

export default component.exports